import { ApolloClient, gql } from '@apollo/client'

/**
 * Every saved filter the user has, for all tables at once (the hook narrows
 * the list to its own table). A gql-only LEAF (PRO-130): the boot batch
 * (src/App/router.tsx) and the sign-in sequences take it from here, never
 * from the hook module beside it (`./api`), which brings the star menu's UI
 * (antd, icons, transifex) with it. `useSavedFiltersApi` reads it
 * cache-first, so a list fetched ahead costs a table no round trip.
 */
export const ALL_USER_FILTER_COLLECTIONS = gql`
  query AllUserFilterCollections(
    $tableKey: String
    $name: String
    $isDefault: Boolean
  ) {
    allUserFilterCollections(
      tableKey: $tableKey
      name: $name
      isDefault: $isDefault
    ) {
      edges {
        node {
          id
          name
          filters
          isDefault
          tableKey
        }
      }
    }
  }
`

/**
 * LO-22: a sign-in starts from an empty Apollo cache and lands with no
 * reload, so the boot batch never runs for it. The first table opened after
 * it fetched the list itself and adopted the user's default a round trip late
 * (Live Operations had its board answered unfiltered, then queried it again).
 * The sign-in sequences send this beside GetMe. Fire-and-forget: if it fails,
 * the hook fetches the list itself, as before.
 */
export const prefetchSavedFilters = (
  client: Pick<ApolloClient<object>, 'query'>
) => client.query({ query: ALL_USER_FILTER_COLLECTIONS }).catch(() => undefined)
